module.exports = __webpack_public_path__ + "img/pistar_logo_black.27f2186b.png";